import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ComponentsModule } from '../components/components.module';
import { DecimalPipe } from '@angular/common';
import { ProvidersModule } from '../providers/providers.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import {
  CurrencyMaskConfig,
  CURRENCY_MASK_CONFIG
} from 'ng2-currency-mask/src/currency-mask.config';
import { Facebook } from '@ionic-native/facebook';
import { SocialSharing } from '@ionic-native/social-sharing';
import { FirebaseServiceProvider } from '../providers/firebase-service/firebase-service';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { FileHelpersModule } from 'ngx-file-helpers';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FlurryProvider } from '../providers/flurry/flurry';
import {
  FlurryAnalytics,
  FlurryAnalyticsObject,
  FlurryAnalyticsOptions
} from '@ionic-native/flurry-analytics';
import { IonicStorageModule } from '@ionic/storage';
import { Keyboard } from '@ionic-native/keyboard';
import { Firebase } from '@ionic-native/firebase';
import { Device } from '@ionic-native/device';
import { Clipboard } from '@ionic-native/clipboard';
import { BranchIo } from '@ionic-native/branch-io';
import { AppSettings } from '../app/app.settings';
import { AngularFireModule } from '@angular/fire';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  allowZero: false,
  decimal: '.',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: ','
};

@NgModule({
  declarations: [MyApp],
  imports: [
    CurrencyMaskModule,
    FileHelpersModule,
    ComponentsModule,
    BrowserModule,
    ProvidersModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp, {
      menuType: 'overlay',
      preloadModules: true,
      mode: 'md',
      scrollAssist: true,
      autoFocusAssist: false,
      scrollPadding: false
    }),
    AngularFireModule.initializeApp(AppSettings.getFirebaseConfig())
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    Firebase,
    StatusBar,
    SplashScreen,
    InAppBrowser,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    DecimalPipe,
    Facebook,
    SocialSharing,
    FirebaseServiceProvider,
    FlurryProvider,
    FlurryAnalytics,
    Device,
    Clipboard,
    Keyboard,
    BranchIo
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts